export const it = {
  uploading: "Carica ...",
  uploaded: "caricato",
  fetching: "Ottieni immagine da $1$ ...",
  poweredBy: "Reso possibile da $1$",
  needHelp: "Hai bisogno di aiuto?",
  units: {
    px: "px",
    "%": "%",
    deg: "°"
  },
  errors: {
    response_not_ok:
      "Si è verificato un errore durante il recupero di questo file",
    unable_to_search: "Si è verificato un errore durante la ricerca",
    invalid_service_url: "Questo non è un $1$ URL",
    invalid_url: "Questo URL non è valido",
    upload_aborted: "Il tuo caricamento è stato annullato",
    upload_error:
      "Si è verificato un errore durante il caricamento di questo file",
    file_type_not_allowed: "Questo tipo di file non è supportato",
    file_too_large: "Il file deve essere inferiore a $1$"
  },
  help: {
    loading: "Caricamento della guida...",
    close: "Aiuto vicino"
  },
  services: {
    default: {
      heading: "Seleziona un'immagine"
    },
    local: {
      title: "Scegli un file",
      button: "Seleziona un file",
      or: "di",
      drop: "Trascina qui un file per caricarlo"
    },
    camera: {
      title: "telecamera",
      button: "Foto della webcam",
      switch: "Cambia fotocamera",
      waiting: "In attesa di autorizzazione della fotocamera ...",
      unableToRead:
        "Non possiamo leggere il video dalla tua fotocamera. Ciò può essere dovuto al fatto che non hai concesso l'autorizzazione richiesta o perché il tuo dispositivo non supporta l'accesso alla videocamera."
    },
    microlink: {
      button: "Importa da $1$",
      label: "$1$ $2$ URL",
      placeholder: "Inserisci un URL da $1$ $2$",
      type: "inviare"
    },
    url: {
      title: "URL diretto",
      label: "URL immagine",
      placeholder: "Inserisci un URL immagine"
    },
    instagram: {
      title: "Instagram"
    },
    facebook: {
      title: "Facebook"
    },
    flickr: {
      title: "Flickr",
      type: "una foto"
    },
    ninegag: {
      title: "9GAG",
      type: "una foto"
    },
    deviantart: {
      title: "DeviantArt"
    },
    artstation: {
      title: "ArtStation"
    },
    twitter: {
      title: "cinguettio",
      type: "tweet fotografico"
    },
    pinterest: {
      title: "Pinterest",
      type: "perno"
    },
    flipboard: {
      title: "Flipboard",
      type: "articolo"
    },
    fotki: {
      title: "foto",
      type: "una foto"
    },
    linkedin: {
      title: "LinkedIn"
    },
    reddit: {
      title: "Reddit"
    },
    tumblr: {
      title: "Tumblr"
    },
    weheartit: {
      title: "We Heart It"
    },
    screenshot: {
      title: "Immagine dello schermo",
      button: "Fai uno screenshot",
      label: "URL della pagina web",
      placeholder: "Inserisci un URL",
      loading: "Fai uno screenshot ..."
    },
    search: {
      button: "Cerca $1$",
      label: "Cerca un'immagine",
      placeholder: "Cerca qualcosa",
      imagesPoweredBy: "Immagini rese possibili da $1$"
    },
    giphy: {
      title: "GIPHY"
    },
    unsplash: {
      title: "Unsplash"
    },
    pixabay: {
      title: "Pixabay"
    },
    pexels: {
      title: "Pexels"
    }
  },
  effects: {
    preview: {
      title: "esempio"
    },
    filters: {
      title: "filtri"
    },
    crop: {
      title: "raccolto",
      aspectRatios: {
        free: "Gratuito",
        square: "pieno"
      }
    },
    rotate: {
      title: "torcere"
    },
    flip: {
      title: "Voltati",
      buttons: {
        horizontal: "orizzontale",
        vertical: "verticale"
      }
    },
    sharpen: {
      title: "affinare"
    },
    blur: {
      title: "dissolvenza"
    },
    brightness: {
      title: "luminosità"
    },
    contrast: {
      title: "Contrasto"
    },
    grayscale: {
      title: "Scala di grigi"
    },
    "hue-rotate": {
      title: "Ruota tonalità"
    },
    invert: {
      title: "Girare"
    },
    saturate: {
      title: "satiate"
    },
    sepia: {
      title: "nero di seppia"
    }
  }
};
